import { MoodboardApi } from '../../../api/moodboard-api';
import { MOOD_CATEGORY_LOADING } from './moodboard-categories';
import { clientDesignOnboarding2 } from '../../../../common/onboarding/onboarding';

export const LOAD_MORE_SCROLL_POS = 300;

export const MOOD_LIST_MAIN = 'main';
export const MOOD_LIST_ALTERNATIVE = 'alternative';
export const ALTERNATIVE_WIDTH = 72;
export const TYPE_PRODUCT = 'product';
export const TYPE_CUSTOM = 'custom';
export const TYPE_PREVIEW = 'preview';

export const getCategoryPos = (categories, category) => {
  let pos = 0;
  for (let i = 0; i < categories.length; i++) {
    if (categories[i].id === category.id) {
      return pos;
    }
    if (categories[i].column === category.column) {
      pos++;
    }
  }
  return -1;
};

export const getColumnSize = (categories, column) => {
  let size = 0;
  for (let i = 0; i < categories.length; i++) {
    if (categories[i].column === column) {
      size++;
    }
  }
  return size;
};

const setCategoryLoading = (dispatch, categoryId, loading) => {
  dispatch({ type: MOOD_CATEGORY_LOADING, payload: { categoryId, loading } });
};

const handler = (dispatch, categoryId, callback) => {
  return data => {
    if (callback) {
      callback(data);
    }
    setCategoryLoading(dispatch, categoryId);
  };
};

export const Api = {
  addProduct: (dispatch, categoryId, list, product, position, onSuccess) => {
    setCategoryLoading(dispatch, categoryId, true);
    MoodboardApi.addProduct(
      categoryId,
      list,
      product,
      position,
      handler(dispatch, categoryId, onSuccess),
      handler(dispatch, categoryId),
    );
  },

  removeProduct: (dispatch, categoryId, list, product, onSuccess) => {
    setCategoryLoading(dispatch, categoryId, true);
    MoodboardApi.removeProduct(
      categoryId,
      list,
      product,
      handler(dispatch, categoryId, onSuccess),
      handler(dispatch, categoryId),
    );
  },

  updateMoodboardProduct: (dispatch, categoryId, product, onSuccess) => {
    setCategoryLoading(dispatch, categoryId, true);
    MoodboardApi.updateMoodboardProduct(
      categoryId,
      product,
      handler(dispatch, categoryId, onSuccess),
      handler(dispatch, categoryId),
    );
  },

  createCategory: (dispatch, product, category, onSuccess) => {
    setCategoryLoading(dispatch, null, true);
    MoodboardApi.createCategory(
      product,
      category,
      handler(dispatch, null, onSuccess),
      handler(dispatch, null),
    );
  },

  copyCategory: (dispatch, mooboardId, categoryId, params, onSuccess) => {
    setCategoryLoading(dispatch, categoryId, true);
    MoodboardApi.copyCategory(
      mooboardId,
      categoryId,
      params,
      handler(dispatch, null, onSuccess),
      handler(dispatch, null),
    );
  },

  updateCategory: (dispatch, categoryId, attrs, onSuccess) => {
    setCategoryLoading(dispatch, categoryId, true);
    MoodboardApi.updateCategory(
      categoryId,
      attrs,
      handler(dispatch, categoryId, onSuccess),
      handler(dispatch, categoryId),
    );
  },

  moveCategory: (dispatch, categoryId, column, position, onSuccess) => {
    setCategoryLoading(dispatch, categoryId, true);
    MoodboardApi.moveCategory(
      categoryId,
      column,
      position,
      handler(dispatch, categoryId, onSuccess),
      handler(dispatch, categoryId),
    );
  },

  removeCategory: (dispatch, categoryId, onSuccess) => {
    setCategoryLoading(dispatch, categoryId, true);
    MoodboardApi.removeCategory(
      categoryId,
      handler(dispatch, categoryId, onSuccess),
      handler(dispatch, categoryId),
    );
  },

  setFavoutite: (dispatch, categoryId, favourite, onSuccess) => {
    // setCategoryLoading(dispatch, categoryId, true);
    MoodboardApi.toggleCategoryFavourite(
      categoryId,
      favourite,
      handler(dispatch, categoryId, onSuccess),
      handler(dispatch, categoryId),
    );
  },
};

export const getCategoryList = (category, action) => {
  let list = typeof action === 'string' ? action : action.payload.list;
  return list === MOOD_LIST_MAIN ? category.products : category.alternatives;
};

export const getTotal = categories => {
  let total = 0;
  categories.forEach(category => {
    if (category.products) {
      category.products.forEach(product => {
        // debugger;
        total += (product.quantity || 1) * (product.sale_price || product.price || 0);
      });
    }
  });
  return Math.round(total);
};

export const getCommission = categories => {
  let commission = 0;

  categories.forEach(category => {
    if (category.products) {
      category.products.forEach(product => {
        commission += (product.quantity || 1) * (product.commission || 0);
      });
    }
  });
  return Math.round(commission);
};

export const recountTotal = state => {
  state.total = getTotal(state.categories);
  state.commission = getCommission(state.categories);
};

export const recountProductsOverlays = state => {
  const categories = state.categories;
  const collection = state.collection;
  if (categories || collection) {
    const customProducts = state.customProducts || [];
    const products = [...state.products, ...customProducts];

    const processList = (list, name) => {
      if (list) {
        list.forEach(product => {
          const shopProduct = products.find(i => i.id === product.id);
          if (shopProduct) {
            shopProduct.categories.push(name);
          }
        });
      }
    };

    products.forEach(product => {
      product.categories = [];
    });

    if (categories) {
      categories.forEach(category => {
        processList(category.products, category.name);
        processList(category.alternatives, category.name);
      });
    }

    if (collection) {
      processList(collection.products, 'added');
    }
  }
};

export const showOnboardingMessage = state => {
  const { categories } = state;
  if (categories.length === 1) {
    const category = categories[0];
    if (category.products.length === 1) {
      clientDesignOnboarding2();
    }
  }
};
//
// export const currencyFormatter = new Intl.NumberFormat('en-GB', {
//   style: 'currency',
//   currency: 'GBP',
//   minimumFractionDigits: 2,
// });



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Moodboard/modules/common.js